export const findWlData = (whitelabelRoot = [], key = '') => {
  if (whitelabelRoot.length > 0) {
    const findSitename = whitelabelRoot.filter((e) => e.key === key);
    if (findSitename.length > 0) {
      return findSitename[0].value;
    }
  }
  return null;
};
